import { useQuery } from '@apollo/client';
import { TenantLeaseInfo } from 'graphql-query-contracts';
import { fetchTenantLeasesQuery } from 'graphql-queries';

export type FetchTenantLeasesQueryResponse = {
  tenant: {
    leases: TenantLeaseInfo[];
  };
};

export const useFetchTenantLeases = (tenantId: string, propertyId: string) => {
  const { loading, error, data, refetch } =
    useQuery<FetchTenantLeasesQueryResponse>(fetchTenantLeasesQuery, {
      variables: { tenantId, propertyId },
      skip: !tenantId || !propertyId,
    });

  const tenantLeases = data?.tenant?.leases || [];

  return {
    loading,
    error,
    tenantLeases,
    refetch,
  };
};
